
export default function ComparisonTable() {
  const cards = [
    {
      name: '三井住友カード（NL）',
      annualFee: '永年無料',
      insurance: '最大2,000万円',
      insuranceType: '利用付帯',
      lounge: '×',
      cashAdvance: '○',
      brand: 'Visa/Mastercard',
      href: '/mitsui',
    },
    {
      name: '大手ECモール系カード',
      annualFee: '永年無料',
      insurance: '最大2,000万円',
      insuranceType: '利用付帯',
      lounge: '×',
      cashAdvance: '○',
      brand: 'Visa/Mastercard/JCB/AMEX',
      href: '/rakuten',
    },
    {
      name: 'dカード GOLD U',
      annualFee: '11,000円',
      insurance: '最大1億円',
      insuranceType: '自動付帯',
      lounge: '○',
      cashAdvance: '○',
      brand: 'Visa/Mastercard',
      href: '/dcard',
    },
    {
      name: 'JAカード',
      annualFee: '1,375円',
      insurance: '最大3,000万円',
      insuranceType: '自動付帯',
      lounge: '×',
      cashAdvance: '○',
      brand: 'Visa/Mastercard/JCB',
      href: '/ja',
    },
    {
      name: 'リクルートカード',
      annualFee: '永年無料',
      insurance: '最大2,000万円',
      insuranceType: '利用付帯',
      lounge: '×',
      cashAdvance: '○',
      brand: 'Visa/Mastercard/JCB',
      href: '/recruit',
    },
  ];

  return (
    <section id="comparison" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-block bg-gradient-to-r from-sky-100 to-cyan-100 text-sky-700 px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold mb-4">
            📊 比較表
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            海外旅行向けカード<span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-cyan-600">スペック比較</span>
          </h2>
          <p className="text-gray-600 text-sm sm:text-base max-w-2xl mx-auto">
            海外旅行に重要な項目を一覧で比較できます
          </p>
        </div>

        {/* デスクトップ用テーブル */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gradient-to-r from-sky-500 to-cyan-500 text-white">
                <th className="px-4 py-4 text-left font-bold rounded-tl-xl">カード名</th>
                <th className="px-4 py-4 text-center font-bold">年会費</th>
                <th className="px-4 py-4 text-center font-bold">海外旅行保険</th>
                <th className="px-4 py-4 text-center font-bold">付帯条件</th>
                <th className="px-4 py-4 text-center font-bold">空港ラウンジ</th>
                <th className="px-4 py-4 text-center font-bold">海外キャッシング</th>
                <th className="px-4 py-4 text-center font-bold">ブランド</th>
                <th className="px-4 py-4 text-center font-bold rounded-tr-xl">詳細</th>
              </tr>
            </thead>
            <tbody>
              {cards.map((card, index) => (
                <tr
                  key={index}
                  className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-sky-50 transition-colors`}
                >
                  <td className="px-4 py-4 font-bold text-gray-900">{card.name}</td>
                  <td className="px-4 py-4 text-center">
                    <span className={`${card.annualFee === '永年無料' ? 'text-emerald-600 font-bold' : 'text-gray-700'}`}>
                      {card.annualFee}
                    </span>
                  </td>
                  <td className="px-4 py-4 text-center font-medium text-sky-600">{card.insurance}</td>
                  <td className="px-4 py-4 text-center">
                    <span className={`px-2 py-1 rounded-full text-xs font-bold ${card.insuranceType === '自動付帯' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`}>
                      {card.insuranceType}
                    </span>
                  </td>
                  <td className="px-4 py-4 text-center">
                    <span className={`${card.lounge === '○' ? 'text-emerald-600' : 'text-gray-400'} font-bold`}>
                      {card.lounge}
                    </span>
                  </td>
                  <td className="px-4 py-4 text-center text-emerald-600 font-bold">{card.cashAdvance}</td>
                  <td className="px-4 py-4 text-center text-sm text-gray-600">{card.brand}</td>
                  <td className="px-4 py-4 text-center">
                    <a
                      href={card.href}
                      className="inline-flex items-center gap-1 text-sky-600 hover:text-sky-700 font-medium cursor-pointer"
                    >
                      詳細
                      <i className="ri-arrow-right-s-line"></i>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* モバイル用カード */}
        <div className="md:hidden space-y-4">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden"
            >
              <div className="bg-gradient-to-r from-sky-500 to-cyan-500 px-4 py-3">
                <h3 className="font-bold text-white">{card.name}</h3>
              </div>
              <div className="p-4 space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">年会費</span>
                  <span className={`font-bold ${card.annualFee === '永年無料' ? 'text-emerald-600' : 'text-gray-900'}`}>
                    {card.annualFee}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">海外旅行保険</span>
                  <span className="font-bold text-sky-600">{card.insurance}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">付帯条件</span>
                  <span className={`px-2 py-1 rounded-full text-xs font-bold ${card.insuranceType === '自動付帯' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`}>
                    {card.insuranceType}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">空港ラウンジ</span>
                  <span className={`font-bold ${card.lounge === '○' ? 'text-emerald-600' : 'text-gray-400'}`}>
                    {card.lounge}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-500 text-sm">ブランド</span>
                  <span className="text-gray-700 text-sm">{card.brand}</span>
                </div>
                <a
                  href={card.href}
                  className="block w-full text-center bg-sky-500 hover:bg-sky-600 text-white font-bold py-3 rounded-lg transition-colors cursor-pointer mt-4"
                >
                  詳細を見る
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
